import React from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase/app';
import 'firebase/database';
import RichTextArea from '../rich-text-area/rich-text-area';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import Spinner from '../spinner/spinner';

/** @class GiftCardInstructions
  * A component for editing the instructions on
  * how to use gift cards.
  * @param {Object} props - the component's properties
  */
export default class GiftCardInstructions extends ReactFireComponent {
  constructor(props){
    super(props);
    this.state = {
      instructions: ''
    }
    this.dataRef = firebase.database().ref(props.dataURL + '/messages/giftCardUse');
    this.dataURL = props.dataURL + '/messages';
    this.handleChange = this.handleChange.bind(this);
  }
  /** @function componentWillMount
    * Connects the component to its firebase realtime
    * database entry
    */
  componentWillMount(){
    this.dataRef.on('value', snapshot => {
      if(snapshot) {
        this.setState({instructions: snapshot.val()});
      } else {
        this.setState({instructions: '?'});
      }
    });
  }
  /** @function componentWillUnmount
    * Disconnects the component from the firebase database.
    */
  componentWillUnmount(){
    this.dataRef.off();
  }
  /** @function handleChange
    * Responds to text editor events in
    * the gift card instructions.
    */
  handleChange(html) {
    this.dataRef.set(html);
  }
  /** @function render
    * Renders the component
    */
  render() {
    if(!this.state.instructions) return <Spinner />
    return (
      <div className="input-group">
        <p className="info-panel">
          These instructions are included in the email
          sent to users who have purhcased gift cards, and
          also added to thier showbag.
        </p>
        <RichTextArea
          name="giftCardInstructions"
          value={this.state.instructions}
          onChange={this.handleChange}/>
      </div>
    )
  }
}

GiftCardInstructions.propTypes = {
  dataURL: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/gift-card-editor/gift-card-instructions.js